import { DateFilterStrategy } from 'src/app/utils/reportType';

/**
 * Business Summary Response DTO used to interact with backend
 * @param {string} reportType
 * @param {date} startDate
 * @param {date} endDate
 * @param {DateFilterStrategy} dateFilterStrategy
 */
export class DownloadReportDTO {
  /**
   * @constructor
   */
  constructor(
    public reportType: string,
    public startDate?: string,
    public endDate?: string,
    public dateFilterStrategy?: DateFilterStrategy
  ) {}
}
